module.exports = __webpack_public_path__ + "static/media/trust_icon_registration.08162dcb.svg";